module.exports = __webpack_public_path__ + "static/media/icon_custom_appbar_filter_black.883123af.svg";